import React, {FC} from 'react';
import {Route, Switch} from 'react-router-dom';

import {JasperReport} from 'components/jasper-report/jasper-report';
import {IPageTemplateProps} from 'pages';

export const JasperReportPage: FC<IPageTemplateProps> = ({
    url,
    entityName,
}: IPageTemplateProps) => (
    <Switch>
        <Route
            path={url}
            render={() => (
                <JasperReport entityName={entityName} />
            )}
        />
    </Switch>
);
